import { render, staticRenderFns } from "./MyTextareaComment.vue?vue&type=template&id=d2ec4e40"
import script from "./MyTextareaComment.vue?vue&type=script&lang=js"
export * from "./MyTextareaComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports